'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _VideoTutorials = require('./VideoTutorials.css');

var _VideoTutorials2 = _interopRequireDefault(_VideoTutorials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoTutorials = (_dec = (0, _reactCssModules2.default)(_VideoTutorials2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(VideoTutorials, _Component);

  function VideoTutorials(props) {
    (0, _classCallCheck3.default)(this, VideoTutorials);
    return (0, _possibleConstructorReturn3.default)(this, (VideoTutorials.__proto__ || (0, _getPrototypeOf2.default)(VideoTutorials)).call(this, props));
  }

  (0, _createClass3.default)(VideoTutorials, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Video tutorials';
      var description = 'Watch our video tutorials to learn how to get your money out of fossil fuels.';
      var url = _config2.default.domain + _config2.default.routes.videoTutorials;

      var thumbs = [['492212055', require('../../../static/images/video-thumbnail-1-introduction.png'), 'An introduction', 'Learn the basics of our sites, with a focus on Fossil Free Funds. We\'ll show you how to find your fund holdings and grades, use search filters, and more.'], ['519720867', require('../../../static/images/video-thumbnail-2-finding-fund.png'), 'Finding my fund', 'Learn how to find your fund and fund grades.'], ['520123964', require('../../../static/images/video-thumbnail-3-navigating-sites.png'), 'Navigating sites', 'Learn how to jump between sites to learn the details on why and how each fund grade is assigned across our seven sites.'], ['520182245', require('../../../static/images/video-thumbnail-4-fund-families.png'), 'Fund families', 'We analyze funds from over a hundred different asset managers. Learn how to find fund families and see an overview of the holdings.'], ['519712485', require('../../../static/images/video-thumbnail-5-search-filters.png'), 'Fund search filters', 'Learn how to apply different filters during your fund search, so you can find top rated funds according to the issues you care about the most.'], ['519695062', require('../../../static/images/video-thumbnail-6-comparing-funds.png'), 'Comparing funds', 'Learn how to easily compare funds side by side, and analyze their financial performance, fund grades, and more.']];

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lede' },
            _react2.default.createElement(
              'p',
              null,
              'Our database exposes unsustainable investments hidden in your retirement funds, and helps you find cleaner alternatives. Click a video below to learn how to get the most of our tools.'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'video-thumbnail-row' },
              thumbs.map(function (e, i) {
                return _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    key: 'video-thumbnail-col-' + i,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    styleName: 'video-thumbnail-col'
                  },
                  _react2.default.createElement(
                    _components.VideoModal,
                    { vimeoId: thumbs[i][0] },
                    _react2.default.createElement(
                      _reactFlexboxGrid.Row,
                      null,
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { xs: 12, sm: 12, md: 6 },
                        _react2.default.createElement('img', {
                          styleName: 'video-thumbnail-img',
                          src: thumbs[i][1],
                          alt: thumbs[i][2]
                        })
                      ),
                      _react2.default.createElement(
                        _reactFlexboxGrid.Col,
                        { xs: 12, sm: 12, md: 6 },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'video-thumbnail-summary-wrap' },
                          _react2.default.createElement(
                            'p',
                            { styleName: 'video-thumbnail-summary' },
                            thumbs[i][3]
                          ),
                          _react2.default.createElement(
                            'p',
                            { styleName: 'video-thumbnail-play' },
                            'Play video',
                            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-play' })
                          )
                        )
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return VideoTutorials;
}(_react.Component)) || _class);
exports.default = VideoTutorials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/VideoTutorials/VideoTutorials.js
// module id = 1423
// module chunks = 0